import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";

import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

import "../scss/style.scss";
import "../scss/sign.scss";

class Home extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="signLayout">
					<div className="signin-guide">
						<p>
							서비스 이용을 위해서
							<br />
							도서관을 등록하세요
						</p>
					</div>
					<div className="form-group">
						<input
							className="form-input form-input-lg"
							type="text"
							placeholder="도서관 이름을 입력해 주세요"
						/>
						<div className="signin-divider">
							<span className="signin-divider-text">OR</span>
						</div>
						<Button variant="contained" fullWidth="true" className="btn-sign">
							<SearchOutlinedIcon />
							지도에서 도서관 찾기
						</Button>
					</div>
					<div className="promocode">
						<a>프로모션 코드가 있습니다.</a>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Home;
